import ReactDOM from 'react-dom/client';
import { App } from '@/App';
import 'antd/dist/reset.css'; // Restablece los estilos predeterminados del navegador y normaliza la apariencia en todos los navegadores
import './index.css';

ReactDOM.createRoot(document.getElementById('app')).render(
  <App />
);